import { applyEmojiAutoComplete } from 'emoji'
let observer
const textcompletes = new Map()
const destroyDetachedTextcompletes = () => {
  for (const [textarea, textcomplete] of textcompletes) {
    if (textarea.isConnected) { continue }
    textcomplete.destroy()
    textcompletes.delete(textarea)
  }
}
document.addEventListener('turbo:load', () => {
  if (observer !== undefined) {
    return
  }
  applyEmojiAutoComplete(document.getElementsByTagName('textarea'), textcompletes)
  const mutationCallback = (mutationList) => {
    mutationList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE || !node.isConnected) { return }
        const textareas = node.matches('textarea') ? [node] : node.getElementsByTagName('textarea')
        applyEmojiAutoComplete(textareas, textcompletes)
      })
    })
    destroyDetachedTextcompletes()
  }
  observer = new MutationObserver(mutationCallback)
  observer.observe(document, { childList: true, subtree: true })
})
